export const COMPANY = {
  name: "SMT Provence",
  tagline: "Maçonnerie générale & aménagements extérieurs",
  dirigeant: "Michel Zappitelli",
  phone: "06 27 08 17 59",
  phoneAlt: "04 42 69 02 13",
  phoneHref: "+33627081759",
  email: "contact@smtprovence.fr",
  address: "665 Avenue du Raumartin, 13730 Saint-Victoret",
  siret: "953 104 759 00014",
  tva: "FR87953104759",
  ape: "4399C",
  logo: "/media/logo.png",
  heroVideo: "/media/hero-video.mp4",
  bessonLogo: "/media/besson-b.png",
  bessonLogoWhite: "/media/besson-b.png",
  zones: "Saint-Victoret, Marignane, Vitrolles, Marseille, Aix-en-Provence et tout le département des Bouches-du-Rhône (13).",
  version: "1.0",
  lastUpdate: "6 juillet 2026",
};

export const CLIENT_TYPES = [  { key: "particuliers", label: "Particuliers", desc: "Maisons, extensions, murs, terrasses et rénovations pour votre habitat.", icon: "Home" },
  { key: "professionnels", label: "Professionnels & Entreprises", desc: "Locaux, bâtiments d'activité, sous-traitance gros œuvre pour vos projets.", icon: "Briefcase" },
  { key: "collectivites", label: "Collectivités & Structures publiques", desc: "Marchés publics, ouvrages structurels et réhabilitation du patrimoine.", icon: "Landmark" },
];

export const PARTNERS = [
  { name: "Ville de Saint-Victoret" },
  { name: "Qualibat" },
  { name: "RGE" },
  { name: "Point.P" },
  { name: "Fédération BTP 13" },
  { name: "Métropole Aix-Marseille" },
  { name: "Weber" },
  { name: "Lafarge" },
];

export const IMAGES = {
  hero: "/media/hero.jpg",
  heroAlt: "/media/svc-maconnerie.jpg",
  about: "/media/about.jpg",
  cta: "/media/svc-maconnerie.jpg",
};

export const SERVICE_IMG = {
  "maconnerie-generale": "/media/svc-maconnerie.jpg",
  "renovation-rehabilitation": "/media/svc-renovation.jpg",
  "beton-ouvrages-structurels": "/media/svc-beton.jpg",
  "murs-clotures": "/media/svc-murs.jpg",
  "vrd-reseaux": "/media/svc-vrd.jpg",
  "finitions-reprises": "/media/svc-finitions.jpg",
};

export const SERVICE_DETAILS = {  "maconnerie-generale": ["Chapes et ragréages", "Élévation de murs porteurs", "Cloisons maçonnées", "Ouvertures dans murs porteurs", "Reprises en sous-œuvre", "Gros œuvre complet"],
  "renovation-rehabilitation": ["Démolition partielle", "Réfection de murs", "Consolidation de structures", "Réaménagement intérieur / extérieur", "Adaptations techniques sur chantier"],
  "beton-ouvrages-structurels": ["Dalles béton armé", "Fondations", "Planchers", "Seuils et linteaux", "Éléments structurels"],
  "murs-clotures": ["Murs de clôture", "Murs de soutènement", "Murs séparatifs", "Ouvrages maçonnés", "Portails et piliers"],
  "vrd-reseaux": ["Terrasses", "Allées et escaliers extérieurs", "Murets et bordures", "Piliers et clôtures", "Dalles béton", "Réseaux et évacuations"],
  "finitions-reprises": ["Rebouchage", "Reprise de fissures", "Réparation d'enduits", "Scellements", "Raccords de maçonnerie", "Finitions diverses"],
};
